module.exports = __webpack_public_path__ + "static/img/super-chat-pass.ba175a5e.png";